const PRISMIC_CLI_NPM_PACKAGE_NAME = "@prismicio/cli";
export {
  PRISMIC_CLI_NPM_PACKAGE_NAME
};
//# sourceMappingURL=PRISMIC_CLI_NPM_PACKAGE_NAME.js.map
